import SeoHeader from './SeoHeader';

export default SeoHeader;
